const state = {
  roles: [
    {
      id: 1,
      name: '超级管理员',
      code: 'admin',
      description: '拥有系统所有权限',
      permissions: ['*'],
      status: 'active',
      createdAt: '2026-01-01T00:00:00'
    },
    {
      id: 2,
      name: '运营人员',
      code: 'operator',
      description: '负责用户管理和日常运营',
      permissions: [
        'user:view',
        'user:edit',
        'debt:view',
        'task:view',
        'credit:view',
        'dashboard:view'
      ],
      status: 'active',
      createdAt: '2026-01-01T00:00:00'
    },
    {
      id: 3,
      name: '财务人员',
      code: 'finance',
      description: '负责财务审核和结算',
      permissions: [
        'debt:view',
        'debt:edit',
        'credit:view',
        'credit:edit',
        'merchant:view',
        'dashboard:view'
      ],
      status: 'active',
      createdAt: '2026-01-01T00:00:00'
    },
    {
      id: 4,
      name: '客服人员',
      code: 'customer_service',
      description: '负责用户咨询和问题处理',
      permissions: [
        'user:view',
        'debt:view',
        'task:view',
        'dashboard:view'
      ],
      status: 'active',
      createdAt: '2026-01-01T00:00:00'
    }
  ],
  permissions: [
    {
      id: 1,
      name: '查看用户',
      code: 'user:view',
      description: '可以查看用户列表和详情',
      module: '用户管理',
      status: 'active'
    },
    {
      id: 2,
      name: '编辑用户',
      code: 'user:edit',
      description: '可以添加、修改、删除用户',
      module: '用户管理',
      status: 'active'
    },
    {
      id: 3,
      name: '查看债务',
      code: 'debt:view',
      description: '可以查看债务列表和详情',
      module: '债务管理',
      status: 'active'
    },
    {
      id: 4,
      name: '编辑债务',
      code: 'debt:edit',
      description: '可以添加、修改、删除债务',
      module: '债务管理',
      status: 'active'
    },
    {
      id: 5,
      name: '查看任务',
      code: 'task:view',
      description: '可以查看任务列表和详情',
      module: '任务管理',
      status: 'active'
    },
    {
      id: 6,
      name: '编辑任务',
      code: 'task:edit',
      description: '可以添加、修改、删除任务',
      module: '任务管理',
      status: 'active'
    },
    {
      id: 7,
      name: '查看积分',
      code: 'credit:view',
      description: '可以查看积分列表和详情',
      module: '积分管理',
      status: 'active'
    },
    {
      id: 8,
      name: '编辑积分',
      code: 'credit:edit',
      description: '可以添加、修改、删除积分',
      module: '积分管理',
      status: 'active'
    },
    {
      id: 9,
      name: '查看商户',
      code: 'merchant:view',
      description: '可以查看商户列表和详情',
      module: '商户管理',
      status: 'active'
    },
    {
      id: 10,
      name: '编辑商户',
      code: 'merchant:edit',
      description: '可以添加、修改、删除商户',
      module: '商户管理',
      status: 'active'
    },
    {
      id: 11,
      name: '查看仪表盘',
      code: 'dashboard:view',
      description: '可以查看系统仪表盘',
      module: '系统管理',
      status: 'active'
    },
    {
      id: 12,
      name: '查看操作日志',
      code: 'log:view',
      description: '可以查看系统操作日志',
      module: '系统管理',
      status: 'active'
    },
    {
      id: 13,
      name: '查看权限管理',
      code: 'permission:view',
      description: '可以查看权限和角色管理',
      module: '系统管理',
      status: 'active'
    },
    {
      id: 14,
      name: '编辑权限管理',
      code: 'permission:edit',
      description: '可以编辑权限和角色',
      module: '系统管理',
      status: 'active'
    }
  ],
  adminRoles: [
    {
      id: 1,
      adminId: 1,
      roleId: 1,
      roleName: '超级管理员',
      assignedAt: '2026-01-01T00:00:00'
    },
    {
      id: 2,
      adminId: 2,
      roleId: 2,
      roleName: '运营人员',
      assignedAt: '2026-02-01T00:00:00'
    },
    {
      id: 3,
      adminId: 3,
      roleId: 3,
      roleName: '财务人员',
      assignedAt: '2026-02-01T00:00:00'
    },
    {
      id: 4,
      adminId: 4,
      roleId: 4,
      roleName: '客服人员',
      assignedAt: '2026-02-01T00:00:00'
    }
  ]
}

const mutations = {
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  },
  SET_ADMIN_ROLES: (state, adminRoles) => {
    state.adminRoles = adminRoles
  },
  ADD_ROLE: (state, role) => {
    state.roles.push(role)
  },
  UPDATE_ROLE: (state, role) => {
    const index = state.roles.findIndex(r => r.id === role.id)
    if (index !== -1) {
      state.roles.splice(index, 1, role)
    }
  },
  DELETE_ROLE: (state, id) => {
    const index = state.roles.findIndex(r => r.id === id)
    if (index !== -1) {
      state.roles.splice(index, 1)
    }
  },
  ADD_PERMISSION: (state, permission) => {
    state.permissions.push(permission)
  },
  UPDATE_PERMISSION: (state, permission) => {
    const index = state.permissions.findIndex(p => p.id === permission.id)
    if (index !== -1) {
      state.permissions.splice(index, 1, permission)
    }
  },
  DELETE_PERMISSION: (state, id) => {
    const index = state.permissions.findIndex(p => p.id === id)
    if (index !== -1) {
      state.permissions.splice(index, 1)
    }
  },
  ADD_ADMIN_ROLE: (state, adminRole) => {
    state.adminRoles.push(adminRole)
  },
  REMOVE_ADMIN_ROLE: (state, { adminId, roleId }) => {
    const index = state.adminRoles.findIndex(ar => ar.adminId === adminId && ar.roleId === roleId)
    if (index !== -1) {
      state.adminRoles.splice(index, 1)
    }
  }
}

const actions = {
  // 获取角色列表
  fetchRoles({ commit }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(state.roles)
      }, 300)
    })
  },
  
  // 获取权限列表
  fetchPermissions({ commit }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(state.permissions)
      }, 300)
    })
  },
  
  // 获取管理员角色分配
  fetchAdminRoles({ commit }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(state.adminRoles)
      }, 300)
    })
  },
  
  // 创建角色
  createRole({ commit }, roleData) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const newRole = {
          id: Date.now(),
          ...roleData,
          status: 'active',
          createdAt: new Date().toISOString()
        }
        commit('ADD_ROLE', newRole)
        resolve(newRole)
      }, 500)
    })
  },
  
  // 更新角色
  updateRole({ commit }, roleData) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('UPDATE_ROLE', roleData)
        resolve(roleData)
      }, 500)
    })
  },
  
  // 删除角色
  deleteRole({ commit }, id) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('DELETE_ROLE', id)
        resolve()
      }, 500)
    })
  },
  
  // 创建权限
  createPermission({ commit }, permissionData) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const newPermission = {
          id: Date.now(),
          ...permissionData,
          status: 'active'
        }
        commit('ADD_PERMISSION', newPermission)
        resolve(newPermission)
      }, 500)
    })
  },
  
  // 更新权限
  updatePermission({ commit }, permissionData) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('UPDATE_PERMISSION', permissionData)
        resolve(permissionData)
      }, 500)
    })
  },
  
  // 删除权限
  deletePermission({ commit }, id) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('DELETE_PERMISSION', id)
        resolve()
      }, 500)
    })
  },
  
  // 分配角色给管理员
  assignRoleToAdmin({ commit }, { adminId, roleId }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const newAdminRole = {
          id: Date.now(),
          adminId,
          roleId,
          roleName: state.roles.find(r => r.id === roleId)?.name || '未知角色',
          assignedAt: new Date().toISOString()
        }
        commit('ADD_ADMIN_ROLE', newAdminRole)
        resolve(newAdminRole)
      }, 500)
    })
  },
  
  // 移除管理员角色
  removeRoleFromAdmin({ commit }, { adminId, roleId }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('REMOVE_ADMIN_ROLE', { adminId, roleId })
        resolve()
      }, 500)
    })
  }
}

const getters = {
  roles: state => state.roles,
  permissions: state => state.permissions,
  adminRoles: state => state.adminRoles,
  getRoleById: state => id => state.roles.find(role => role.id === id),
  getPermissionById: state => id => state.permissions.find(permission => permission.id === id),
  getAdminRolesByAdminId: state => adminId => state.adminRoles.filter(ar => ar.adminId === adminId),
  getPermissionsByModule: state => module => state.permissions.filter(p => p.module === module)
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
